<template>
  <div class="third-login">
    <div class="third-login-box">
      <template v-for="(item, index) in curShowLoginList">
        <div v-if="loginHref[item]" :key="index" class="third-box">
          <a
            class="login-type"
            href="javascript:;"
            :class="`j-${item}-login-btn`"
            @click="loginHrefJump(loginHref[item], item)"
          >
            <em :class="item" :title="channelName[item]"></em>
          </a>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import login from '@mixins/officialTopup/login';
import { CHANNEL_NAME } from '@store/officialTopup/login';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV3';
export default {
  mixins: [login],
  data() {
    return {
      channelName: CHANNEL_NAME
    };
  },
  computed: {
    ...mapState({
      gameId: state => state.gameId
    }),
    curShowLoginList() {
      // 判断是跟随游戏配置还是跟支付页配置
      return this.isFollowGameLogin ? this.loginType : this.thirdList;
    }
  },
  watch: {
    gameId: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          return;
        }
        this.getThirdPartyLogin();
      }
    }
  },
  methods: {
    loginHrefJump(href, loginType) {
      clickButton({
        btnName: 'third_login_clike',
        locationKey: locationType.loginPopup,
        otherParams: {
          loginType: loginType
        }
      });
      window.open(href, '_self');
    }
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialTopup/_dimen.scss';
.third-login {
  &-box {
    font-size: 0;
    text-align: center;
    margin-bottom: 30px;
    .third-box {
      display: inline-block;
      .login-type {
        text-decoration: none;
        display: inline-block;
        margin: auto 25px auto;
        .facebook,
        .twitter,
        .line,
        .naver,
        .apple,
        .googleplay {
          width: 68px;
          height: 68px;
        }
      }
    }

    @each $icon in facebook, twitter, kakao, line, naver, googleplay, apple, vk
    {
      .#{$icon} {
        background: url($commonLoginImg + $icon + '.png')
          no-repeat
          center
          center;
        background-size: contain;
        width: 68px;
        height: 68px;
        display: block;
        margin: auto;
        transition: all 0.2s;
      }
    }
  }
}
</style>
